// eslint-disable-next-line max-len
import { getCategoryDataProps } from './types';

export const getCategoryData = async ({
  reset,
  categoryId,
  setState,
  getCategoryById
}: getCategoryDataProps) => {
  setState((prev) => ({ ...prev, isLoading: true }))

  try {
    const category = await getCategoryById(categoryId).unwrap()

    if (!category) {
      alert('Something went wrong.')

      return
    }

    reset({
      ...category,
    })
    setState((prev) => ({ ...prev, isLoading: false }))
  } catch (error) {
    setState((prev) => ({ ...prev, isLoading: false }))
  }
}
